import { AdvanceSearch } from "apiEndPoints";
import { logger } from "utils";
import APIrequest from "../../axios";

export const AdvanceSearchServices = {
  searchService: async ({ queryParams }) => {
    try {
      const payload = {
        ...AdvanceSearch.userSearch,
        queryParams,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
};
